import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import {
  CheckTextSelect,
  DemanderKbn,
  DispDepositType,
  DomesticResidenceFlg,
  IncomeKbn,
  RetireKbn,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "退職手当金請求書",
  },
  {
    title: "勤務先",
    keyword: "facilityName",
    type: "text",
    disabled: true,
  },
  {
    title: "（退職者）氏名",
    keyword: "staffNameKanji",
    type: "text",
    disabled: true,
  },
  {
    title: "（退職者）生年月日",
    keyword: "birthday",
    type: "date",
    disabled: true,
  },
  {
    title: "被共済職員期間",
    keyword: "maePeriod",
    type: "text",
    disabled: true,
  },
  {
    title: "退職日",
    keyword: "finalRetireDate",
    type: "date",
    disabled: true,
  },
  {
    title: "退職理由",
    keyword: "retirementReason",
    type: "text",
    disabled: true,
  },
  {
    title: "請求者区分",
    keyword: "demanderKbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(DemanderKbn),
    disabled: true,
  },
  {
    title: "請求者氏名（ｶﾅ）",
    keyword: "demanderNameKana",
    type: "text",
    disabled: true,
  },
  {
    title: "請求者氏名（全角漢字）",
    keyword: "demanderName",
    type: "text",
    disabled: true,
  },
  {
    title: "請求者生年月日",
    keyword: "demanderBirth",
    type: "date",
    disabled: true,
  },
  {
    title: "請求者現住所（郵便番号）",
    keyword: "demanderZipcode",
    type: "text",
    disabled: true,
  },
  {
    title: "請求者現住所",
    keyword: "demanderCity",
    type: "text",
    disabled: true,
  },
  {
    title: "請求者連絡先",
    keyword: "tel",
    type: "text",
    disabled: true,
  },
  {
    title: "請求者メールアドレス（機構連絡用）",
    keyword: "demanderEmail",
    type: "text",
    disabled: true,
  },
  {
    title: "代行者連絡先メールアドレス",
    keyword: "agentEmail",
    type: "text",
    disabled: true,
  },
  {
    title: "金融機関コード",
    keyword: "bankCd",
    type: "text",
    disabled: true,
  },
  {
    title: "金融機関名",
    keyword: "bankName",
    type: "text",
    disabled: true,
  },
  {
    title: "支店コード",
    keyword: "branchCd",
    type: "text",
    disabled: true,
  },
  {
    title: "支店名",
    keyword: "branchName",
    type: "text",
    disabled: true,
  },
  {
    title: "預金種目",
    keyword: "depositType",
    type: "radio",
    radioPropsList: TkGetCodeList(DispDepositType),
    disabled: true,
  },
  {
    title: "口座番号",
    keyword: "accountNo",
    type: "text",
    disabled: true,
  },
  {
    title: "口座名義人名（半角ｶﾀｶﾅ）",
    keyword: "accountNameKana",
    type: "text",
    disabled: true,
  },
  {
    title: "海外送金",
    keyword: "sendMoneyAbroad",
    type: "checkboxGroup",
    checkBoxList: [{ label: "海外送金", disabled: true }],
    showLine: true,
  },
  {
    title: "国内居住",
    keyword: "domesticResidenceFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(DomesticResidenceFlg),
    disabled: true,
  },
  {
    title: "「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathOrAutopsyReport",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "内縁関係についての「生計維持に関する調査書」（様式１１号）",
    keyword: "marriageReport",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」",
    keyword: "certificateOfResidence",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "その他、事実上の配偶者であることを証明する書類",
    keyword: "claimantPartnerBook",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "確認する書類の選択",
    keyword: "identificationDocsKind",
    type: "selectForm",
    selectPropsList: TkGetCodeList(CheckTextSelect),
    disabled: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identityDocs1",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identityDocs2",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類（表面）",
    keyword: "identityDocHead",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "本人であることを確認するための書類（裏面）",
    keyword: "identityDocTail",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "死亡した退職者の個人番号を確認する書類",
    keyword: "deceasedRetireeNumCheckDoc",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "旧姓と新姓が確認できる住民票",
    keyword: "nameConfirmation",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "個人番号を確認する書類",
    keyword: "numberCheckDoc",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "振込先口座が確認できる書類",
    keyword: "payAccountCheckDoc",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "振込先金融口座が確認できる書類",
    keyword: "financialAccountConfirm",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "氏名が変更されていることを確認できる書類",
    keyword: "nameChangedConfirm",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "委任状",
    keyword: "commission",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: "退職所得の受給に関する申告書兼退職所得申告書",
  },
  {
    title: "法人が添付した源泉徴収票（1枚目）",
    keyword: "attachedTax1",
    type: "nodeInLine",
    showLine: false,
  },
  {
    title: "法人が添付した源泉徴収票（2枚目）",
    keyword: "attachedTax2",
    type: "nodeInLine",
    showLine: false,
  },
  {
    title: "法人が添付した源泉徴収票（3枚目）",
    keyword: "attachedTax3",
    type: "nodeInLine",
    showLine: false,
  },
  {
    title: "退職所得の源泉徴収票（1枚目）",
    keyword: "page1RetireeTax",
    type: "nodeInLine",
  },
  {
    title: "就労年月日（1枚目）",
    keyword: "page1EmployedDate",
    type: "date",
    disabled: true,
  },
  {
    title: "退職年月日（1枚目）",
    keyword: "page1RetiredDate",
    type: "date",
    disabled: true,
  },
  {
    title: "区分（1枚目）",
    keyword: "page1Kbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(IncomeKbn),
    disabled: true,
  },
  {
    title: "支払金額（1枚目）",
    keyword: "page1PaymentAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "源泉徴収額（1枚目）",
    keyword: "page1WithholdingAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "特別徴収税額:市町村民税（1枚目）",
    keyword: "page1ScAmtCity",
    type: "amount",
    disabled: true,
  },
  {
    title: "特別徴収税額:都道府県税（1枚目）",
    keyword: "page1ScAmtPrefecture",
    type: "amount",
    disabled: true,
  },
  {
    title: "勤続年数（1枚目）",
    keyword: "page1LengthOfService",
    type: "amount",
    innerText: "年",
    disabled: true,
  },
  {
    title: "1枚目の控除期間（年）",
    keyword: "page1DeductionPeriodYear",
    type: "inputWithText",
    innerText: "年",
    onlyNumber: true,
    useNumberValue: true,
    showLine: false,
    inputProps: { maxLength: 2, style: { textAlign: "end" } },
    disabled: true,
  },
  {
    title: "1枚目の控除期間（月）",
    keyword: "page1DeductionPeriodMonth",
    type: "inputWithText",
    innerText: "月",
    onlyNumber: true,
    useNumberValue: true,
    showLine: false,
    inputProps: { maxLength: 2, style: { textAlign: "end" } },
    disabled: true,
  },

  {
    title: "退職所得の源泉徴収票（2枚目）",
    keyword: "page2RetireeTax",
    type: "nodeInLine",
  },
  {
    title: "就労年月日（2枚目）",
    keyword: "page2EmployedDate",
    type: "date",
    disabled: true,
  },
  {
    title: "退職年月日（2枚目）",
    keyword: "page2RetiredDate",
    type: "date",
    disabled: true,
  },
  {
    title: "区分（2枚目）",
    keyword: "page2Kbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(IncomeKbn),
    disabled: true,
  },
  {
    title: "支払金額（2枚目）",
    keyword: "page2PaymentAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "源泉徴収額（2枚目）",
    keyword: "page2Tax",
    type: "amount",
    disabled: true,
  },
  {
    title: "特別徴収税額:市町村民税（2枚目）",
    keyword: "page2ScAmtCity",
    type: "amount",
    disabled: true,
  },
  {
    title: "特別徴収税額:都道府県税（2枚目）",
    keyword: "page2ScAmtPrefecture",
    type: "amount",
    disabled: true,
  },
  {
    title: "勤続年数（2枚目）",
    keyword: "page2LengthOfService",
    type: "amount",
    innerText: "年",
    disabled: true,
  },
  {
    title: "2枚目の控除期間（年）",
    keyword: "page2DeductionPeriodYear",
    type: "inputWithText",
    innerText: "年",
    onlyNumber: true,
    useNumberValue: true,
    showLine: false,
    inputProps: { maxLength: 2, style: { textAlign: "end" } },
    disabled: true,
  },
  {
    title: "2枚目の控除期間（月）",
    keyword: "page2DeductionPeriodMonth",
    type: "inputWithText",
    innerText: "月",
    onlyNumber: true,
    useNumberValue: true,
    showLine: false,
    inputProps: { maxLength: 2, style: { textAlign: "end" } },
    disabled: true,
  },
  {
    title: "重複勤続年数",
    keyword: "duplicationLosYear",
    type: "inputWithText",
    innerText: "年",
    onlyNumber: true,
    useNumberValue: true,
    showLine: false,
    inputProps: { maxLength: 2, style: { textAlign: "end" } },
    disabled: true,
  },
  {
    title: "重複期間",
    keyword: "duplicationLos",
    type: "durationPicker",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    showLine: false,
    round: "floorAdd",
  },
  {
    title: "氏名",
    keyword: "retirementStaffName",
    type: "name",
    disabled: true,
  },
  {
    title: "現住所",
    keyword: "nowAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "個人番号",
    keyword: "number",
    type: "text",
    text: "別添の個人番号確認書類のとおり",
  },
  {
    title: "その年１月１日現在の住所",
    keyword: "yearOneToOnelocation",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "【A】①　退職手当等の支払を受けることとなった年月日",
    keyword: "paymentConfirmDate",
    type: "date",
    disabled: true,
  },
  {
    title: "【A】②　退職区分等",
    keyword: "retireKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(RetireKbn),
    disabled: true,
  },
  {
    title: "【A】生活扶助の有無",
    keyword: "livingAssistanceFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
  },
  {
    title: "【A】③　この申告書の提出先から受ける退職手当等についての勤続期間", //退職手当等についての勤続期間（自）と退職手当等についての勤続期間（至）を設定する。
    keyword: "joinAndRetireDate",
    type: "durationPicker",
    disabled: true,
    round: "floorAdd",
  },
  {
    title: "【B】他の退職金の支払いの有無",
    keyword: "otherRetireeMoneyYesOrNoPageB",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
  },
  {
    title: "【B】④本年中に支払を受けた他の退職手当等についての勤続期間",
    keyword: "currentYearLos",
    type: "durationPicker",
    showYears: false,
  },
  {
    title: "【B】⑤　③と④の通算勤続期間",
    keyword: "areaBNo5",
    type: "durationPicker",
    disabled: true,
    round: "floorAdd",
  },
  {
    title: "【C】他の退職金の支払いの有無",
    keyword: "otherRetireeMoneyYesOrNoPageC",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
  },
  {
    title:
      "【C】⑥　前年以前４年内に支払を受けた他の退職手当等についての勤続期間",
    keyword: "past4yearsLos",
    type: "durationPicker",
    showYears: false,
  },
  {
    title: "【C】⑦　③又は⑤の勤続期間のうち、⑥の勤続期間と重複している期間",
    keyword: "areaCNo7",
    type: "durationPicker",
    showYears: false,
  },
  {
    title: "【D】通算の有無",
    keyword: "TotalOrNotPageD",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
  },
  {
    title:
      "【D】⑧　Ａの退職手当等についての勤続期間（③）に通算された前の退職手当等についての勤続期間",
    keyword: "pastLosInCurrentYearTotal",
    type: "durationPicker",
    showYears: false,
  },
  {
    title:
      "【D】⑨　Ｂの退職手当等についての勤続期間（④）に通算された前の退職手当等についての勤続期間",
    keyword: "pastLosInCurrentYearOther",
    type: "durationPicker",
    showYears: false,
  },
  {
    title:
      "【D】⑩　③又は⑤の勤続期間のうち、⑧又は⑨の勤続期間だけからなる部分の期間",
    keyword: "areaDNo10",
    type: "durationPicker",
    showYears: false,
  },
  {
    title: "【D】⑪ ⑦と⑩の通算期間",
    keyword: "areaDNo11",
    type: "durationPicker",
    showYears: false,
  },
  {
    title: "【E】B欄又はC欄の退職手当等の有無",
    keyword: "RetirementAllowancePageE",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
  },
  {
    title: "【E】区分B　退職手当等の支払を受けることとなった年月日",
    keyword: "currentYearPaymentDecisionDate",
    type: "date",
    disabled: true,
  },
  {
    title: "【E】区分B　収入金額",
    keyword: "currentYearRetirementAllowanceAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "【E】区分B　源泉徴収額",
    keyword: "currentYearWithholdingAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "【E】区分B　特別徴収税額（市町村民税）",
    keyword: "currentYearScCityAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "【E】区分B　特別徴収税額（都道府県民税）",
    keyword: "currentYearScPrefectureAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "【E】区分B　支払いを受けた年月日",
    keyword: "currentYearGetPaidDate",
    type: "date",
    disabled: true,
  },
  {
    title: "【E】区分B　退職の区分",
    keyword: "currentYearRetirementKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(RetireKbn),
    disabled: true,
  },
  {
    title: "【E】区分B　支払者の所在地（住所）（郵便番号）",
    keyword: "currentYearPayerZipcode",
    type: "postcode",
    disabled: true,
  },
  {
    title: "【E】区分B　支払者の所在地（住所）",
    keyword: "currentYearPayerAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "【E】区分B　支払者の名称（氏名）（全角）",
    keyword: "currentYearPayerName",
    type: "name",
    disabled: true,
  },
  {
    title: "【E】区分C　退職手当等の支払を受けることとなった年月日",
    keyword: "past4yearsPaymentDecisionDate",
    type: "date",
    disabled: true,
  },
  {
    title: "【E】区分C　収入金額",
    keyword: "past4yearsRetirementAllowanceAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "【E】区分C　源泉徴収額",
    keyword: "past4yearsWithholdingAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "【E】区分C　特別徴収税額（市町村民税）",
    keyword: "past4yearsScCityAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "【E】区分C　特別徴収税額（都道府県民税）",
    keyword: "past4yearsScPrefectureAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "【E】区分C　支払いを受けた年月日",
    keyword: "past4yearsGetPaidDate",
    type: "date",
    disabled: true,
  },
  {
    title: "【E】区分C　退職の区分",
    keyword: "past4yearsRetirementKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(RetireKbn),
    disabled: true,
  },
  {
    title: "【E】区分C　支払者の所在地（住所）（郵便番号）",
    keyword: "past4yearsPayerZipcode",
    type: "postcode",
    disabled: true,
  },
  {
    title: "【E】区分C　支払者の所在地（住所）",
    keyword: "past4yearsPayerAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "【E】区分C　支払者の名称（氏名）（全角）",
    keyword: "past4yearsPayerName",
    type: "name",
    disabled: true,
  },
];

const headList: any = [
  {
    headTitle: "決裁日",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
];

const fileDisplayMap: { [key: string]: string[] } = {
  identityDocs1: [
    CheckTextSelect["個人番号カード（１２桁の番号のある面）"],
    CheckTextSelect["個人番号が記載された住民票＋写真無し身分証明２点"],
    CheckTextSelect["通知カード＋写真無し身分証明２点"],
  ],
  identityDocs2: [
    CheckTextSelect["個人番号が記載された住民票＋写真無し身分証明２点"],
    CheckTextSelect["通知カード＋写真無し身分証明２点"],
  ],
  identityDocHead: [
    CheckTextSelect["個人番号が記載された住民票＋写真付き身分証明１点"],
    CheckTextSelect["通知カード＋写真付き身分証明１点"],
  ],
  identityDocTail: [
    CheckTextSelect["個人番号が記載された住民票＋写真付き身分証明１点"],
    CheckTextSelect["通知カード＋写真付き身分証明１点"],
  ],
};

export { fakeTableList, headList, fileDisplayMap };
